import getVisitorId from 'tracking/lib/getVisitorId'

import { acquisitionTrackingRequest } from '@/sdk/oauth'

const logger = require('debug')('careship:collector')

export default function identifyVisitor(): void {
  const visitor_id = getVisitorId()

  if (visitor_id) {
    logger('identifyVisitor called with payload: %O', { visitor_id })
    acquisitionTrackingRequest.post('/identify-visitor', { visitor_id })
  }
}
